var render, staticRenderFns
import script from "./cargoElSelect.vue?vue&type=script&lang=js&"
export * from "./cargoElSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ee8a04')) {
      api.createRecord('46ee8a04', component.options)
    } else {
      api.reload('46ee8a04', component.options)
    }
    
  }
}
component.options.__file = "src/components/Cargo/Common/cargoElSelect.vue"
export default component.exports